import _ from 'lodash';
import { getColor } from '../../../Map/drawing';

export const merge_regional_data = (attrs = {}, filteringState) => {
  const {
    regional_info,
    distribution_house_summary,
    high_balance_agent_summary,
    dh_stock_balance_lifting_summary,
    dh_stock_progress_summary,
    dh_stock_balance_agent_summary,
    agent_with_transaction_summary,
    leading_agent_summary,
    leading_agent_tpv_summary,
    leading_agent_category_summary,
    milking_agent_summary,
    active_agent_summary,
    active_agent_without_disbursement_summary,
    active_agent_partner_payment_summary
  } = attrs;
  if (!regional_info) return null;
  if (filteringState.distribution_house && !distribution_house_summary)
    return null;
  if (filteringState.high_balance_agents && !high_balance_agent_summary)
    return null;
  if (filteringState.dh_stock_progress && !dh_stock_progress_summary)
    return null;
  if (filteringState.dh_stock_balance_agent && !dh_stock_balance_agent_summary)
    return null;
  if (filteringState.agent_with_transaction && !agent_with_transaction_summary)
    return null;
  if (filteringState.leading_agents && !leading_agent_summary) return null;
  if (filteringState.leading_agent_tpv && !leading_agent_tpv_summary)
    return null;
  if (filteringState.leading_agent_category && !leading_agent_category_summary)
    return null;
  if (filteringState.active_agents && !active_agent_summary) return null;
  if (
    filteringState.active_agent_without_disbursement_cashout &&
    !active_agent_without_disbursement_summary
  )
    return null;
  if (
    filteringState.active_agent_partner_payment_only &&
    !active_agent_partner_payment_summary
  )
    return null;
  if (filteringState.milking_agent && !milking_agent_summary) return null;
  if (
    filteringState.dh_stock_balance_lifting &&
    !dh_stock_balance_lifting_summary
  )
    return null;
  return regional_info.map(info => {
    const dh = _.find(distribution_house_summary, { id: info.id });
    const high_balance_agent = _.find(high_balance_agent_summary, {
      id: info.id
    });
    const dh_stock_balance_lifting = _.find(dh_stock_balance_lifting_summary, {
      id: info.id
    });
    const dh_stock_progress = _.find(dh_stock_progress_summary, {
      id: info.id
    });
    const dh_stock_balance_agent = _.find(dh_stock_balance_agent_summary, {
      id: info.id
    });
    const agent_with_transaction = _.find(agent_with_transaction_summary, {
      id: info.id
    });
    const leading_agent = _.find(leading_agent_summary, {
      id: info.id
    });
    const leading_agent_tpv = _.find(leading_agent_tpv_summary, {
      id: info.id
    });
    const leading_agent_category = _.find(leading_agent_category_summary, {
      id: info.id
    });
    const milking_agent = _.find(milking_agent_summary, { id: info.id });
    const active_agent = _.find(active_agent_summary, { id: info.id });
    const active_agent_without_disbursment = _.find(
      active_agent_without_disbursement_summary,
      { id: info.id }
    );
    const active_agent_partner_payment = _.find(
      active_agent_partner_payment_summary,
      { id: info.id }
    );
    return {
      ...info,
      ...dh,
      ...high_balance_agent,
      ...dh_stock_balance_lifting,
      ...dh_stock_progress,
      ...dh_stock_balance_agent,
      ...agent_with_transaction,
      ...leading_agent,
      ...leading_agent_tpv,
      ...leading_agent_category,
      ...milking_agent,
      ...active_agent,
      ...active_agent_without_disbursment,
      ...active_agent_partner_payment
    };
  });
};

export const merge_regional_marker_data = (attrs = {}) => ({
  active_distribution_houses: attrs.activeDistributionHouses,
  high_balance_agents: attrs.highBalanceAgents,
  dh_stock_balance_liftings: attrs.dhStockBalanceLiftings,
  dh_stock_progress: attrs.dhStockProgress,
  dh_stock_balance_agents: attrs.dhStockBalanceAgents,
  active_agents: attrs.activeAgents,
  active_agents_without_disbursment: attrs.activeAgentsWithoutDisbursement,
  active_agents_partner_payment: attrs.activeAgentsPartnerPayment,
  agents_with_transaction: attrs.agentsWithTransaction,
  leading_agents: attrs.leadingAgents,
  leading_agents_tpv: attrs.leadingAgentsTpv,
  leading_gold_agents: attrs.leadingGoldAgents,
  leading_silver_agents: attrs.leadingSilverAgents,
  leading_bronze_agents: attrs.leadingBronzeAgents,
  milking_agents: attrs.milkingAgents
});

const get_choropleth_density_by_state = (
  regional_info,
  filteringState,
  extraOption = {}
) => {
  if (filteringState.distribution_house)
    return (
      regional_info.passing_distribution_houses /
      regional_info.total_distribution_houses
    );
  else if (filteringState.high_balance_agents) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.high_balance_agents));
    const max = Math.max(...info_list.map(info => info.high_balance_agents));
    return min !== max
      ? (regional_info.high_balance_agents - min) / (max - min)
      : 1;
  } else if (
    filteringState.dh_stock_balance_lifting ||
    filteringState.dh_stock_balance_agent
  ) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.max_stock));
    const max = Math.max(...info_list.map(info => info.max_stock));
    return min !== max ? (regional_info.max_stock - min) / (max - min) : 1;
  } else if (filteringState.dh_stock_progress) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.avg_max_stock_t1));
    const max = Math.max(...info_list.map(info => info.avg_max_stock_t1));
    return min !== max
      ? (regional_info.avg_max_stock_t1 - min) / (max - min)
      : 1;
  } else if (filteringState.agent_with_transaction) {
    const { info_list } = extraOption;
    const min = Math.min(
      ...info_list.map(info => info.today_passing_tpv_threshold)
    );
    const max = Math.max(
      ...info_list.map(info => info.today_passing_tpv_threshold)
    );
    return min !== max
      ? (regional_info.today_passing_tpv_threshold - min) / (max - min)
      : 1;
  } else if (filteringState.leading_agents) {
    return regional_info.total_leading_agents
      ? regional_info.current_leading_agents /
          regional_info.total_leading_agents
      : 0;
  } else if (filteringState.leading_agent_tpv) {
    const { info_list } = extraOption;
    const min = Math.min(
      ...info_list.map(info => info.total_cash_in + info.total_withdraw)
    );
    const max = Math.max(
      ...info_list.map(info => info.total_cash_in + info.total_withdraw)
    );
    return min !== max
      ? (regional_info.total_cash_in + regional_info.total_withdraw - min) /
          (max - min)
      : 1;
  } else if (filteringState.leading_agent_category) {
    return regional_info.total_leading_agents
      ? regional_info.total_gold_category_agents /
          regional_info.total_leading_agents
      : 0;
  } else if (filteringState.milking_agent) {
    return regional_info.total_milking_agents
      ? regional_info.current_milking_agents /
          regional_info.total_milking_agents
      : 0;
  } else if (filteringState.active_agents) {
    const { info_list } = extraOption;
    const min = Math.min(...info_list.map(info => info.total_active_agents));
    const max = Math.max(...info_list.map(info => info.total_active_agents));
    return min !== max
      ? (regional_info.total_active_agents - min) / (max - min)
      : 1;
  } else if (filteringState.active_agent_without_disbursement_cashout) {
    const { info_list } = extraOption;
    const min = Math.min(
      ...info_list.map(info => info.active_agents_without_disbursment)
    );
    const max = Math.max(
      ...info_list.map(info => info.active_agents_without_disbursment)
    );
    return min !== max
      ? (regional_info.active_agents_without_disbursment - min) / (max - min)
      : 1;
  } else if (filteringState.active_agent_partner_payment_only) {
    const { info_list } = extraOption;
    const min = Math.min(
      ...info_list.map(info => info.active_agents_partner_payment_only)
    );
    const max = Math.max(
      ...info_list.map(info => info.active_agents_partner_payment_only)
    );
    return min !== max
      ? (regional_info.active_agents_partner_payment_only - min) / (max - min)
      : 1;
  }
  return 1;
};

export const make_choropleth = (map, info_list, filteringState) => {
  if (!map) return;
  return {
    type: 'FeatureCollection',
    features: map.map(geo => {
      const info = _.find(info_list, { map: geo.id });
      return {
        type: 'Feature',
        properties: {
          ...info,
          density: get_choropleth_density_by_state(info, filteringState, {
            info_list
          })
        },
        center: geo.center,
        geometry: geo.geo_json
      };
    })
  };
};

const make_label_str_by_state = (label_info, filteringState) => {
  let decimal_position = 2;
  if (label_info.country) decimal_position = 0;
  let label = '';
  if (filteringState.distribution_house) {
    label += `${
      label_info.passing_distribution_houses
    }:${label_info.total_distribution_houses -
      label_info.passing_distribution_houses}`;
  }
  if (label && filteringState.high_balance_agents) label += '<hr>';
  if (filteringState.high_balance_agents)
    label += `${label_info.high_balance_agents}`;
  if (filteringState.dh_stock_balance_lifting)
    label += `${(label_info.max_stock / 100000).toFixed(2)}, ${(
      label_info.current_balance / 100000
    ).toFixed(2)}, ${(label_info.total_bank_cash_in / 100000).toFixed(2)}`;
  if (filteringState.dh_stock_progress)
    label += `${(label_info.avg_max_stock_t1 / 100000).toFixed(2)}, ${(
      label_info.avg_max_stock_t2 / 100000
    ).toFixed(2)}, ${(label_info.avg_max_stock_t3 / 100000).toFixed(2)}`;
  if (filteringState.dh_stock_balance_agent)
    label += `${(label_info.max_stock / 100000).toFixed(2)}, ${(
      label_info.current_balance / 100000
    ).toFixed(2)}, ${(label_info.agent_balance / 100000).toFixed(2)}`;
  if (filteringState.agent_with_transaction)
    label += `${label_info.today_passing_tpv_threshold}:${label_info.yesterday_to_previous_month_passing_tpv_threshold}`;
  if (filteringState.leading_agents)
    label += `${label_info.current_leading_agents}, ${label_info.previous_leading_agents}, ${label_info.total_leading_agents}`;
  if (filteringState.leading_agent_tpv)
    label += `${(label_info.total_cash_in / 100000).toFixed(
      decimal_position
    )}, ${(label_info.total_withdraw / 100000).toFixed(decimal_position)}, ${(
      (label_info.total_cash_in + label_info.total_withdraw) /
      100000
    ).toFixed(decimal_position)}`;
  if (filteringState.leading_agent_category) {
    label += `<div style="display: flex; justify-content: center"><div style="color: gold">${label_info.total_gold_category_agents}</div>, <div style="color: silver">${label_info.total_silver_category_agents}</div>, <div style="color: #CD7F32">${label_info.total_bronze_category_agents}</div></div>`;
  }
  if (filteringState.milking_agent)
    label += `${label_info.current_milking_agents}, ${label_info.previous_milking_agents}, ${label_info.total_milking_agents}`;
  if (filteringState.active_agents)
    label += `${label_info.total_active_agents}`;
  if (filteringState.active_agent_without_disbursement_cashout)
    label += `${label_info.active_agents_without_disbursment}`;
  if (filteringState.active_agent_partner_payment_only)
    label += `${label_info.active_agents_partner_payment_only}`;

  label = `
    <div class='map-label'>
      <strong>${label_info.name}</strong> <br/>
      ${label}
    </div>`;
  return label;
};

export const make_label_by_state = (map, label_info, filteringState) => {
  if (!map) return;
  return {
    type: 'FeatureCollection',
    features: map.map(geo => {
      const info = _.find(label_info, { map: geo.id });
      return {
        type: 'Feature',
        properties: {
          density: make_label_str_by_state(info, filteringState)
        },
        geometry: {
          type: 'Point',
          coordinates: [geo.center.lng, geo.center.lat]
        }
      };
    })
  };
};

export const make_boundary = map => {
  if (!map) return;
  return {
    type: 'Feature',
    geometry: map.geo_json
  };
};

export const make_legends_by_state = filteringState => {
  var grades = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  var innerHTML = '';
  if (filteringState.distribution_house)
    innerHTML = '<strong>% of Passed DH</strong>';
  else if (filteringState.high_balance_agents)
    innerHTML = '<strong>Count-wise Percentile</strong>';
  else if (
    filteringState.active_agents ||
    filteringState.active_agent_without_disbursement_cashout ||
    filteringState.active_agent_partner_payment_only
  )
    innerHTML = '<strong>Count-wise Percentile</strong>';
  else if (filteringState.agent_with_transaction)
    innerHTML = '<strong>Count-wise Percentile</strong>';
  else if (filteringState.leading_agents)
    innerHTML = '<strong>% of Passed Leading Agent</strong>';
  else if (filteringState.leading_agent_tpv)
    innerHTML = '<strong>TPV-wise Percentile</strong>';
  else if (filteringState.leading_agent_category)
    innerHTML = '<strong>% of Gold Leading Agent</strong>';
  else if (filteringState.milking_agent)
    innerHTML = '<strong>% of Passed Milking Agent</strong>';
  else if (
    filteringState.dh_stock_balance_lifting ||
    filteringState.dh_stock_progress ||
    filteringState.dh_stock_balance_agent
  )
    innerHTML = '<strong>Stock-wise Percentile</strong>';

  for (var i = 0; i < grades.length; i++) {
    innerHTML +=
      '<div class="block"><i style="background:' +
      getColor(grades[i] / 100) +
      '"></i> ' +
      grades[i] +
      (grades[i + 1] ? '&ndash;' + (grades[i + 1] - 1) + '<br>' : '') +
      '</div>';
  }
  return innerHTML;
};

export const make_summary_by_state = (areas_info = [], state) => {
  var summary = 0;
  const total_distribution_houses = areas_info.reduce(
    (total, area) => total + area.total_distribution_houses,
    0
  );

  const total_high_balance_agents = areas_info.reduce(
    (total, area) => total + area.high_balance_agents,
    0
  );

  const total_dh_stock = areas_info.reduce(
    (total, area) => total + area.max_stock,
    0
  );

  const total_current_balance = areas_info.reduce(
    (total, area) => total + area.current_balance,
    0
  );

  const total_bank_cash_in = areas_info.reduce(
    (total, area) => total + area.total_bank_cash_in,
    0
  );

  const total_dh_avg_max_stock_t1 = areas_info.reduce(
    (total, area) => total + area.avg_max_stock_t1,
    0
  );

  const total_dh_avg_max_stock_t2 = areas_info.reduce(
    (total, area) => total + area.avg_max_stock_t2,
    0
  );

  const total_dh_avg_max_stock_t3 = areas_info.reduce(
    (total, area) => total + area.avg_max_stock_t3,
    0
  );

  const total_dh_stock_balance_agent = areas_info.reduce(
    (total, area) => total + area.agent_balance,
    0
  );

  const total_active_agents = areas_info.reduce(
    (total, area) => total + area.total_active_agents,
    0
  );

  const total_active_agents_without_disbursment = areas_info.reduce(
    (total, area) => total + area.active_agents_without_disbursment,
    0
  );

  const total_active_agents_partner_payment_only = areas_info.reduce(
    (total, area) => total + area.active_agents_partner_payment_only,
    0
  );

  const total_tpv_today_passing_threshold = areas_info.reduce(
    (total, area) => total + area.today_passing_tpv_threshold,
    0
  );

  const total_current_leading_agents = areas_info.reduce(
    (total, area) => total + area.current_leading_agents,
    0
  );

  const total_previous_leading_agents = areas_info.reduce(
    (total, area) => total + area.previous_leading_agents,
    0
  );

  const total_leading_agents = areas_info.reduce(
    (total, area) => total + area.total_leading_agents,
    0
  );

  const total_cash_in_of_leading_agents = areas_info.reduce(
    (total, area) => total + area.total_cash_in,
    0
  );

  const total_withdraw_of_leading_agents = areas_info.reduce(
    (total, area) => total + area.total_withdraw,
    0
  );

  const total_tpv_of_leading_agents = areas_info.reduce(
    (total, area) => total + area.total_cash_in + area.total_withdraw,
    0
  );

  const total_gold_category_leading_agent = areas_info.reduce(
    (total, area) => total + area.total_gold_category_agents,
    0
  );

  const total_silver_category_leading_agent = areas_info.reduce(
    (total, area) => total + area.total_silver_category_agents,
    0
  );

  const total_bronze_category_leading_agent = areas_info.reduce(
    (total, area) => total + area.total_bronze_category_agents,
    0
  );

  const total_current_milking_agents = areas_info.reduce(
    (total, area) => total + area.current_milking_agents,
    0
  );

  const total_previous_milking_agents = areas_info.reduce(
    (total, area) => total + area.previous_milking_agents,
    0
  );

  const total_milking_agents = areas_info.reduce(
    (total, area) => total + area.total_milking_agents,
    0
  );

  let decimal_position = 2;
  if (state.selected_state === 'COUNTRY') decimal_position = 0;
  if (state.distribution_house) summary = total_distribution_houses;
  else if (state.high_balance_agents) summary = `${total_high_balance_agents}`;
  else if (state.active_agents) summary = `${total_active_agents}`;
  else if (state.active_agent_without_disbursement_cashout)
    summary = `${total_active_agents_without_disbursment}`;
  else if (state.active_agent_partner_payment_only)
    summary = `${total_active_agents_partner_payment_only}`;
  else if (state.agent_with_transaction)
    summary = `${total_tpv_today_passing_threshold}`;
  else if (state.leading_agents)
    summary = `${total_current_leading_agents}, ${total_previous_leading_agents}, ${total_leading_agents}`;
  else if (state.leading_agent_tpv)
    summary = `${(total_cash_in_of_leading_agents / 100000).toFixed(
      decimal_position
    )}, ${(total_withdraw_of_leading_agents / 100000).toFixed(
      decimal_position
    )}, ${(total_tpv_of_leading_agents / 100000).toFixed(
      decimal_position
    )} (in lac)`;
  else if (state.leading_agent_category)
    summary = `<div style="display: flex"><div style="color: gold">${total_gold_category_leading_agent}</div>, <div style="color: silver">${total_silver_category_leading_agent}</div>, <div style="color: #CD7F32">${total_bronze_category_leading_agent}</div></div>`;
  else if (state.milking_agent)
    summary = `${total_current_milking_agents}, ${total_previous_milking_agents}, ${total_milking_agents}`;
  else if (state.dh_stock_balance_lifting)
    summary = `${(total_dh_stock / 100000).toFixed(2)}, ${(
      total_current_balance / 100000
    ).toFixed(2)}, ${(total_bank_cash_in / 100000).toFixed(2)} (in lac)`;
  else if (state.dh_stock_progress)
    summary = `${(total_dh_avg_max_stock_t1 / 100000).toFixed(2)}, ${(
      total_dh_avg_max_stock_t2 / 100000
    ).toFixed(2)}, ${(total_dh_avg_max_stock_t3 / 100000).toFixed(2)} (in lac)`;
  else if (state.dh_stock_balance_agent)
    summary = `${(total_dh_stock / 100000).toFixed(2)}, ${(
      total_current_balance / 100000
    ).toFixed(2)}, ${(total_dh_stock_balance_agent / 100000).toFixed(
      2
    )} (in lac)`;
  return summary;
};

const make_distribution_house_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Name:</strong> ${info.name} </br>
      <strong>Target:</strong> ${(
        info.high_balance_agent_threshold || 0
      ).toFixed(2)} </br>
      <strong>Balance:</strong> ${(info.balance.balance || 0).toFixed(2)}
  `
});

const make_high_balance_agent_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Wallet:</strong> ${info.wallet} </br>
      <strong>Balance:</strong> ${(info.balance.balance || 0).toFixed(2)}
    `
});

const make_dh_stock_balance_lifting_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Name:</strong> ${info.name} </br>
      <strong>Stock:</strong> ${info.stock_balance.max_stock} </br>
      <strong>Current Balance:</strong> ${info.stock_balance.current_balance} </br>
      <strong>Total Bank Cash In:</strong> ${info.stock_balance.bank_cash_in}
    `
});

const make_dh_stock_balance_progress_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Name:</strong> ${info.name} </br>
      <strong>Stock:</strong> ${info.stock_balance.max_stock} </br>
    `
});

const make_dh_stock_balance_agent_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Name:</strong> ${info.name} </br>
      <strong>Stock:</strong> ${info.stock_balance.max_stock} </br>
      <strong>Current Balance:</strong> ${info.stock_balance.current_balance} </br>
      <strong>Agent Balance:</strong> ${info.stock_balance.all_agent_balance}
    `
});

const make_active_agent_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Wallet:</strong> ${info.wallet} </br>
      <strong>Cash in:</strong> ${info.transaction_info.cash_in_amount} </br>
      <strong>Withdraw:</strong> ${info.transaction_info.withdraw_amount} </br>
      <strong>Partner Payment:</strong> ${info.transaction_info.partner_payment}
    `
});

const make_agent_with_transaction_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Wallet:</strong> ${info.wallet} </br>
      <strong>TPV:</strong> ${(
        info.transaction_info.cash_in_amount +
          info.transaction_info.withdraw_amount || 0
      ).toFixed(2)}
    `
});

const make_leading_agent_marker_info = info => ({
  ...info,
  tooltip: `
      <strong>Wallet:</strong> ${info.wallet} </br>
      <strong>TPV:</strong> ${(
        info.transaction_info.cash_in_amount +
          info.transaction_info.withdraw_amount || 0
      ).toFixed(2)}
    `
});

export const make_markers_by_state = (data, filteringState) => {
  const active_distribution_houses = data.active_distribution_houses
    .filter(dh => dh.location != null)
    .map(dh =>
      make_distribution_house_marker_info({
        ...dh,
        color:
          dh.target.stock_target !== 0 &&
          dh.balance.balance >= dh.target.stock_target
            ? 'green'
            : 'red'
      })
    );
  const high_balance_agents = data.high_balance_agents
    .filter(agent => agent.location != null)
    .map(agent =>
      make_high_balance_agent_marker_info({
        ...agent,
        color: 'green'
      })
    );

  const dh_stock_balance_liftings = data.dh_stock_balance_liftings
    .filter(dh => dh.location != null)
    .map(dh =>
      make_dh_stock_balance_lifting_marker_info({
        ...dh,
        color: 'green'
      })
    );

  const dh_stock_progress = data.dh_stock_progress
    .filter(dh => dh.location != null)
    .map(dh =>
      make_dh_stock_balance_progress_marker_info({
        ...dh,
        color: 'green'
      })
    );

  const dh_stock_balance_agents = data.dh_stock_balance_agents
    .filter(dh => dh.location != null)
    .map(dh =>
      make_dh_stock_balance_agent_marker_info({
        ...dh,
        color: 'green'
      })
    );

  const active_agents_all_transaction = data.active_agents
    .filter(agent => agent.location != null)
    .map(agent => make_active_agent_marker_info({ ...agent }));

  const active_agents_without_disbursement = data.active_agents_without_disbursment
    .filter(
      agent =>
        agent.location != null &&
        agent.transaction_info.without_disbursment_amount >= 5
    )
    .map(agent => make_active_agent_marker_info({ ...agent }));

  const active_agents_partner_payments_only = data.active_agents_partner_payment
    .filter(
      agent =>
        agent.location != null && agent.transaction_info.partner_payment >= 5
    )
    .map(agent => make_active_agent_marker_info({ ...agent }));

  const agents_with_transaction = data.agents_with_transaction
    .filter(agent => agent.location != null)
    .map(agent => make_agent_with_transaction_marker_info({ ...agent }));

  const leading_agents = data.leading_agents
    .filter(agent => agent.location != null)
    .map(agent =>
      make_leading_agent_marker_info({
        ...agent,
        color:
          agent.transaction_info.withdraw_amount +
            agent.transaction_info.cash_in_amount >=
          agent.leading_agent_threshold
            ? 'green'
            : 'red'
      })
    );

  const leading_agents_tpv = data.leading_agents_tpv
    .filter(agent => agent.location != null)
    .map(agent =>
      make_leading_agent_marker_info({
        ...agent,
        color: 'green'
      })
    );

  const leading_gold_agents = data.leading_gold_agents
    .filter(agent => agent.location != null)
    .map(agent =>
      make_leading_agent_marker_info({
        ...agent,
        color: 'gold'
      })
    );

  const leading_silver_agents = data.leading_silver_agents
    .filter(agent => agent.location != null)
    .map(agent =>
      make_leading_agent_marker_info({
        ...agent,
        color: 'silver'
      })
    );

  const leading_bronze_agents = data.leading_bronze_agents
    .filter(agent => agent.location != null)
    .map(agent =>
      make_leading_agent_marker_info({
        ...agent,
        color: 'bronze'
      })
    );

  const milking_agents = data.milking_agents.map(agent =>
    make_leading_agent_marker_info({
      ...agent,
      color:
        agent.transaction_info.withdraw_amount +
          agent.transaction_info.cash_in_amount >=
        agent.milking_agent_threshold
          ? 'green'
          : 'red'
    })
  );

  let markers = [];
  if (filteringState.distribution_house) markers = active_distribution_houses;
  if (filteringState.high_balance_agents)
    markers = [...markers, ...high_balance_agents];
  if (filteringState.dh_stock_balance_lifting)
    markers = dh_stock_balance_liftings;
  if (filteringState.dh_stock_progress) markers = dh_stock_progress;
  if (filteringState.dh_stock_balance_agent) markers = dh_stock_balance_agents;
  if (filteringState.active_agents) markers = active_agents_all_transaction;
  if (filteringState.active_agent_without_disbursement_cashout)
    markers = active_agents_without_disbursement;
  if (filteringState.active_agent_partner_payment_only)
    markers = active_agents_partner_payments_only;
  if (filteringState.agent_with_transaction) markers = agents_with_transaction;
  if (filteringState.leading_agents) markers = leading_agents;
  if (filteringState.leading_agent_tpv) markers = leading_agents_tpv;
  if (filteringState.leading_agent_category)
    markers = [
      ...leading_gold_agents,
      ...leading_silver_agents,
      ...leading_bronze_agents
    ];
  if (filteringState.milking_agent) markers = milking_agents;
  return markers;
};
